module.exports = __webpack_public_path__ + "static/img/1.133df0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myprize/1.png
// module id = dLvq
// module chunks = 1